module.exports = __webpack_public_path__ + "img/Frame 6795@2x.264637e4.png";